import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55834eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = { class: "boxItem" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "boxTitle" }, "菜单ID：", -1))
const _hoisted_4 = { class: "boxItem" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "boxTitle" }, "操作时的菜单名称：", -1))
const _hoisted_6 = { class: "boxItem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "boxTitle" }, "当前最新的菜单名称：", -1))
const _hoisted_8 = { class: "boxItem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "boxTitle" }, "数据唯一键：", -1))
const _hoisted_10 = { class: "boxItem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "boxTitle" }, "操作人：", -1))
const _hoisted_12 = { class: "boxItem" }
const _hoisted_13 = { class: "boxTitle" }
const _hoisted_14 = { class: "boxItem" }
const _hoisted_15 = { class: "boxItem" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-yellow" }, " 触发流程审批的操作，审批通过时，才记录日志！ ", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1. 菜单名称被修改时，当前最新的菜单名称≠操作时的菜单名称", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2. 为空时，表示该菜单已被删除", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }

import { ref, onMounted } from 'vue'
import { formatToTime, getLastTimeRange } from './methods'
import {
  RangePicker,
  Button,
  Input,
  Modal,
  Pagination,
  Table,
  Tooltip,
  TreeSelect
} from "ant-design-vue";
// import Button from 'ant-design-vue/lib/button'
// import Input from 'ant-design-vue/lib/input'
// import Modal from 'ant-design-vue/lib/modal'
// import Pagination from 'ant-design-vue/lib/pagination'
// import Table from 'ant-design-vue/lib/table'
// import Tooltip from 'ant-design-vue/lib/tooltip'
// import TreeSelect from 'ant-design-vue/lib/tree-select'
import LocaleProvider from 'ant-design-vue/lib/locale-provider'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
// import { type LogInfo, type Menu } from './type'
import { type LogInfo, type ISearchForm } from './type'
import diffOne from './components/diffOne.vue'
import diffTwo from './components/diffTwo.vue'
import zhCN from "ant-design-vue/es/locale/zh_CN";
// import dayjs from "dayjs";
// import "dayjs/locale/zh-cn";
// dayjs.locale("zh-cn");


const __default__ = {
  name: "operation-log",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    total: {},
    treeData: {},
    logData: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const bigBoxNew = ref<HTMLDivElement>()
// const props = defineProps<{
//   total: number;
//   treeData: Menu[];
//   logData: LogInfo[]
// }>()
const props = __props
const emit = __emit
const timeRange30 = getLastTimeRange(29, 0)
const searchForm = ref<ISearchForm>({
  menuId: undefined,
  menuName: undefined,
  selectMenuId: undefined,
  uniValue: undefined,
  userName: undefined,
  opTime: [timeRange30.startTime as unknown as number, timeRange30.endTime as unknown as number],
  opStartTime: undefined,
  opEndTime: undefined,
  pageNum: 1,
  pageSize: 10,
})
const visible = ref(false)
const columns = ref([
  { title: '菜单ID', dataIndex: 'menuId', key: 'menuId' },
  { title: '操作时的菜单名称', dataIndex: 'menuName', key: 'menuName' },
  { title: '当前最新的菜单名称', dataIndex: 'curMenuName', key: 'curMenuName' },
  { title: '数据唯一键', dataIndex: 'uniValue', key: 'uniValue' },
  { title: '操作类型', dataIndex: 'operationType', key: 'operationType' },
  { title: '操作内容', dataIndex: 'content', key: 'content' },
  { title: '操作人', dataIndex: 'userName', key: 'userName' },
  { title: '操作时间', dataIndex: 'opTime', key: 'opTime' },
])
const ctx = ref()

const filterTreeNode = (inputValue: string, treeNode: { text: string }) => {
  return `${treeNode.text}`.toLowerCase().includes(inputValue.toLowerCase())
}

const onSearch = () => {
  emit('update', searchForm.value)
}

const changePage = (page: number, pageSize: number) => {
  searchForm.value.pageNum = page
  searchForm.value.pageSize = pageSize
  emit('update', searchForm.value)
}
const initInfo = (record: LogInfo) => {
  ctx.value = record
  visible.value = true
}

const handleClose = () => {
  visible.value = false
}

const onReset = (obj:ISearchForm, pageNum:string, pageSize:string, opTime:string) => {
  Object.keys(obj).forEach(key => {
    console.log(key)
    if (key !== pageNum && key !== pageSize && key !== opTime) {
      obj[key] = undefined
    }
    if (key === pageNum) {
      obj[key] = 1
    }
  })
  emit('update', obj)
  return obj
}

onMounted(() => {
  document.querySelectorAll("style").forEach((item) => {
    if (item.getAttribute("data-cache-path")?.includes("rm38b5")) {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-token-hash") === "rm38b5" || item.getAttribute("data-token-hash") === "1x4g4sz") {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-css-hash")?.includes("1qb1s0s") || item.getAttribute("data-css-hash")?.includes("1hsjdkk")) {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LocaleProvider), { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "bigBoxNew",
        ref: bigBoxNew
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(Input), {
              value: searchForm.value.menuId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.menuId) = $event)),
              class: "w-200"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(Input), {
              value: searchForm.value.menuName,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.value.menuName) = $event)),
              class: "w-200"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(TreeSelect), {
              value: searchForm.value.selectMenuId,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.value.selectMenuId) = $event)),
              "allow-clear": "",
              class: "w-200",
              "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
              "field-names": {
              children: 'children',
              value: 'id',
              label: 'text',
            },
              "filter-tree-node": filterTreeNode,
              "show-search": "",
              "tree-data": JSON.parse(props.treeData),
              "tree-default-expand-all": "",
              "tree-line": { showLeafIcon: false }
            }, null, 8, ["value", "tree-data"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(Input), {
              value: searchForm.value.uniValue,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.value.uniValue) = $event)),
              class: "w-200"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(Input), {
              value: searchForm.value.userName,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.value.userName) = $event)),
              class: "w-200"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode("操作时间 "),
              _createVNode(_unref(Tooltip), { title: "时间范围最长支持90天！" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(InfoCircleOutlined))
                ]),
                _: 1
              }),
              _createTextVNode("： ")
            ]),
            _createVNode(_unref(RangePicker), {
              value: searchForm.value.opTime,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.value.opTime) = $event)),
              class: "w-400",
              "show-time": "",
              allowClear: false
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Button), {
              type: "primary",
              onClick: onSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 查询 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Button), {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (onReset(searchForm.value,'pageNum','pageSize','opTime')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 重置 ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_16,
        _createVNode(_unref(Table), {
          columns: columns.value,
          "data-source": JSON.parse(props.logData),
          pagination: false
        }, {
          headerCell: _withCtx(({ column }) => [
            (column.key === 'curMenuName')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _createTextVNode(" 当前最新的菜单名称 "),
                  _createVNode(_unref(Tooltip), null, {
                    title: _withCtx(() => [
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoCircleOutlined))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (column.key === 'uniValue')
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _createTextVNode(" 数据唯一键 "),
                  _createVNode(_unref(Tooltip), { title: "显示格式：${主接口地址}?id=${数据表中记录的唯一键}" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoCircleOutlined))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'uniValue')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(record.operation) + "?" + _toDisplayString(record.uniValue), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'operationType')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.operationType === 'add')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "增加"))
                    : _createCommentVNode("", true),
                  (record.operationType === 'update')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "修改"))
                    : _createCommentVNode("", true),
                  (record.operationType === 'delete')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "删除"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'content')
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 2,
                  type: "link",
                  onClick: ($event: any) => (initInfo(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查看 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (column.key === 'opTime')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(_unref(formatToTime)(record.opTime)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"]),
        _createVNode(_unref(Pagination), {
          current: searchForm.value.pageNum,
          "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((searchForm.value.pageNum) = $event)),
          pageSize: searchForm.value.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((searchForm.value.pageSize) = $event)),
          "show-quick-jumper": "",
          "show-size-changer": "",
          style: {"margin":"20px 0","float":"right"},
          total: props.total,
          onChange: changePage
        }, null, 8, ["current", "pageSize", "total"]),
        _createVNode(_unref(Modal), {
          open: visible.value,
          "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
          title: "操作内容",
          width: 1500,
          onCancel: handleClose,
          onOk: handleClose
        }, {
          default: _withCtx(() => [
            (ctx.value.needDiff === 0)
              ? (_openBlock(), _createBlock(diffOne, _normalizeProps(_mergeProps({ key: 0 }, ctx.value)), null, 16))
              : (_openBlock(), _createBlock(diffTwo, _normalizeProps(_mergeProps({ key: 1 }, ctx.value)), null, 16))
          ]),
          _: 1
        }, 8, ["open"])
      ], 512)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})